import React from 'react'
import { Helmet } from 'react-helmet-async'
import { HomeLayout } from '../../layouts'

const HomePage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Get Started</title>
      <meta name="description" content="Getting Started Page" />
    </Helmet>
    <HomeLayout />
  </React.Fragment>
)

export default HomePage
